module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Gd-Ha-Ia.c74151f6.png";